import { gql } from 'apollo-boost';

export default gql`
  mutation bizSuspendedOrderStatus($input: BizOrderPauseDateInput!) {
    bizSuspendedOrderStatus(input: $input)
  }
`;
